var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("main", { staticClass: "error-not-found" }, [
      _c("div", { staticClass: "image" }, [
        _c("img", { attrs: { src: "/img/img_404.svg", alt: "404 ERROR" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("h2", { staticClass: "info-heading" }, [
          _vm._v(
            "\n            Huch! Diese Seite konnte leider nicht gefunden werden.\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "info-text" }, [
          _vm._v(
            "\n            Vielleicht wurde die URL falsch eingegeben oder der Link ist veraltet? Kein Problem, denn über die Startseite\n            oder die Suche im Menü gelangst du einfach zum gewünschten Thema rund um HIV.\n        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aed55ac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aed55ac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/ErrorNotFound.vue
// module id = 597
// module chunks = 0